<template>
  <div class="notice-container">
    <el-card class="box-card">
      <template #header>
        <div class="card-header">
          <el-button @click="$router.push('/dashboard')" type="primary" plain style="margin-right: 10px;">
            返回首页
          </el-button>
          <span>通知公告设置</span>
          <el-button type="primary" @click="handleAdd">添加通知</el-button>
        </div>
      </template>
      
      <el-table :data="noticeList" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80" />
        <el-table-column prop="title" label="标题" width="200" />
        <el-table-column prop="content" label="内容" show-overflow-tooltip />
        <el-table-column prop="image_url" label="图片" width="150">
          <template #default="scope">
            <el-image 
              v-if="scope.row.image_url" 
              :src="scope.row.image_url" 
              :preview-src-list="[scope.row.image_url]"
              fit="cover"
              style="width: 100px; height: 60px"
            />
            <span v-else>无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="80" />
        <el-table-column label="状态" width="100">
          <template #default="{ row }">
            <el-tag :type="Number(row.status) === 1 ? 'success' : 'info'">
              {{ Number(row.status) === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="180" />
        <el-table-column prop="updated_at" label="更新时间" width="180" />
        <el-table-column label="操作" width="200" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              size="small"
              @click="handleEdit(row)"
            >
              编辑
            </el-button>
            <el-button
              :type="Number(row.status) === 1 ? 'warning' : 'success'"
              size="small"
              @click="handleStatusChange(row)"
            >
              {{ Number(row.status) === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button
              type="danger"
              size="small"
              @click="handleDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 添加/编辑对话框 -->
    <el-dialog 
      :title="dialogType === 'add' ? '添加通知' : '编辑通知'" 
      v-model="dialogVisible"
      width="600px"
    >
      <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input type="textarea" v-model="form.content" :rows="4" />
        </el-form-item>
        <el-form-item label="图片URL" prop="image_url">
          <el-input v-model="form.image_url" />
        </el-form-item>
        <el-form-item label="排序" prop="sort_order">
          <el-input-number v-model="form.sort_order" :min="0" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import axios from 'axios'

export default {
  name: 'NoticeSettings',
  setup() {
    const loading = ref(false)
    const noticeList = ref([])
    const dialogVisible = ref(false)
    const dialogType = ref('add')
    const formRef = ref(null)
    
    const form = ref({
      title: '',
      content: '',
      image_url: '',
      sort_order: 0,
      status: 1
    })
    
    const rules = {
      title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
      content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
    }
    
    const fetchNoticeList = async () => {
      loading.value = true
      try {
        const response = await fetch('/api/banner.php')
        const data = await response.json()
        if (data.code === 0) {
          noticeList.value = data.data
        } else {
          ElMessage.error(data.msg || '获取通知列表失败')
        }
      } catch (error) {
        console.error('获取通知列表失败:', error)
        ElMessage.error('获取通知列表失败')
      } finally {
        loading.value = false
      }
    }
    
    const handleAdd = () => {
      form.value = {
        title: '',
        content: '',
        image_url: '',
        sort_order: 0,
        status: 1
      }
      dialogType.value = 'add'
      dialogVisible.value = true
    }
    
    const handleEdit = (row) => {
      form.value = { ...row }
      dialogType.value = 'edit'
      dialogVisible.value = true
    }
    
    const handleStatusChange = async (row) => {
      try {
        const action = Number(row.status) === 1 ? '禁用' : '启用'
        await ElMessageBox.confirm(`确定要${action}该通知吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await axios.post('/banner_status.php', {
          id: row.id,
          status: Number(row.status) === 1 ? 0 : 1
        })
        
        if (response.data.code === 0) {
          ElMessage.success(`${action}成功`)
          fetchNoticeList()
        } else {
          ElMessage.error(response.data.msg || `${action}失败`)
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('更新状态失败:', error)
          ElMessage.error('更新状态失败')
        }
      }
    }
    
    const handleDelete = async (row) => {
      try {
        await ElMessageBox.confirm('确定要删除这条通知吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        
        const response = await axios.post('/banner_delete.php', {
          id: row.id
        })
        
        if (response.data.code === 0) {
          ElMessage.success('删除成功')
          fetchNoticeList()
        } else {
          ElMessage.error(response.data.msg || '删除失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          ElMessage.error('删除失败')
        }
      }
    }
    
    const handleSubmit = async () => {
      if (!formRef.value) return
      
      try {
        await formRef.value.validate()
        
        const response = await fetch('/api/banner.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(form.value)
        })
        
        const data = await response.json()
        if (data.code === 0) {
          ElMessage.success(dialogType.value === 'add' ? '添加成功' : '更新成功')
          dialogVisible.value = false
          fetchNoticeList()
        } else {
          ElMessage.error(data.msg || (dialogType.value === 'add' ? '添加失败' : '更新失败'))
        }
      } catch (error) {
        console.error('提交失败:', error)
        ElMessage.error('提交失败')
      }
    }
    
    onMounted(() => {
      fetchNoticeList()
    })
    
    return {
      loading,
      noticeList,
      dialogVisible,
      dialogType,
      formRef,
      form,
      rules,
      fetchNoticeList,
      handleAdd,
      handleEdit,
      handleStatusChange,
      handleDelete,
      handleSubmit
    }
  }
}
</script>

<style scoped>
.notice-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style> 